import api from './api';
import NetworkError from '../utils/error/NetworkError';

import keyBy from 'lodash-es/keyBy';

export const CHANNELS_SET_AVAILABLE = 'CHANNELS_SET_AVAILABLE';
export const CHANNELS_SET_ACTIVE = 'CHANNELS_SET_ACTIVE';
export const CHANNELS_SET_ALTERNATE_RESOURCES = 'CHANNELS_SET_ALTERNATE_RESOURCES';

const initialState = {
  activeChannel: '~',
  activeLocale: '~',
  availableChannels: undefined,
  alternateResources: undefined
};

export default function reducer(state = initialState, {type, payload}) {
  switch (type) {
    case CHANNELS_SET_AVAILABLE:
      return {
        ...state,
        availableChannels: keyBy(payload.map(({current, ...rest}) => rest), 'code'),
        activeChannel: payload.find(it => it.current).code,
        activeLocale: payload.find(it => it.current).defaultLocale.code
      };
    case CHANNELS_SET_ACTIVE:
      return {
        ...state,
        activeChannel: payload.channel,
        activeLocale: state.availableChannels[payload.channel].defaultLocale.code,
        alternateResources: undefined
      };
    case CHANNELS_SET_ALTERNATE_RESOURCES:
      return {
        ...state,
        alternateResources: payload
      };
    default:
      return state;
  }
}

export function setAvailableChannels(channels) {
  return {type: CHANNELS_SET_AVAILABLE, payload: channels};
}

export function setActiveChannel(channel, autoDetected = false) {
  return {type: CHANNELS_SET_ACTIVE, payload: {channel, autoDetected}};
}

export function resetAlternateResources() {
  return {type: CHANNELS_SET_ALTERNATE_RESOURCES, payload: undefined};
}

export function setAlternateResources(resources, prefix = '') {
  if (!resources) {
    return {type: CHANNELS_SET_ALTERNATE_RESOURCES, payload: undefined};
  }

  resources = Object.keys(resources).reduce((acc, channel) => {
    acc[channel] = {
      path: `${prefix}/${resources[channel].slug}`,
      ...resources[channel]
    };

    return acc;
  }, {});

  return {type: CHANNELS_SET_ALTERNATE_RESOURCES, payload: resources};
}

export function fetchChannels(requestedChannel = false, channelDetected = false) {
  return dispatch => dispatch(api.getAll('channels/', undefined, {cache: 'default'}))
    .then(channelsResponse => {
      const channels = channelsResponse.content.items;

      dispatch(setAvailableChannels(channels));

      if (requestedChannel) {
        if (channels.some(it => it.code === requestedChannel)) {
          dispatch(setActiveChannel(requestedChannel, channelDetected));
        } else {
          throw new NetworkError(404, {code: 404, message: 'Channel does not exist'});
        }
      }
    });
}



// WEBPACK FOOTER //
// ./ducks/channels.js